<!--
 * @Author       : 花裤衩<白永明><yongming.bai@outlook.com>
 * @Date         : 2026-01-07 15:43:33 +0800
 * @LastEditors  : 花裤衩<白永明><yongming.bai@outlook.com>
 * @LastEditTime : 2026-07-01 11:49:52 +0800
 * @FilePath     : /ai-agent-lumina/src/components/global/tabs/src/izt-tabs.vue
 * @Description  : tabs组件
-->
<style lang="scss" scoped>
.izt-tabs-container {
  position: relative;
  height: 50px;
  width: 100%;

  .placeholder-container {
    left: 0;
    right: 0;
    display: flex;
    overflow: hidden;
    overflow-x: auto;
    scrollbar-width: none;
    position: absolute;
    bottom: -1px; // 元素变形后 出现的白边处理
  }

  .tab-item {
    height: 50px;
    line-height: 50px;
    font-size: 28px;
    width: 202px;
    padding-left: 30px;
    box-sizing: border-box;
    flex-shrink: 0; // 禁止收缩宽度
    clip-path: polygon(0 0, calc(100% - 25px) 0, 100% 100%, 0 100%);
    border-top-right-radius: 0;
    background-color: var(--izt-theme-color-50);
    transition: all 0.25s ease;
    span {
      font-size: 24px;
      color: var(--izt-mirror-color-85);
      text-align: left;
      font-style: normal;
      transition: font-weight 0.2s ease-in-out;
    }
  }
  .tab-item.unmarked {
    width: 148px;
  }
  .tab-item.active {
    font-weight: bold;
    background-color: var(--izt-theme-color);
  }
}
</style>

<template>
  <div class="izt-tabs-container">
    <div class="placeholder-container overflow-style" ref="tabsContainer">
      <div
        :class="['tab-item', index == active ? 'active' : '']"
        v-for="(item, index) in data"
        @click="handleTabClick(index)"
        :ref="(el) => setTabRef(el, index)">
        <span>{{ formatDateWithWeek(item.date) }}</span>
      </div>
      <div :class="['tab-item unmarked', active == null ? 'active' : '']" @click="handleTabClick(null)">
        <span>待定</span>
      </div>
    </div>
  </div>
</template>

<script setup name="izt-tabs">
import { computed, nextTick, ref, onActivated } from 'vue';
import { formatDateWithWeek } from '@/utils'
defineOptions({ name: 'izt-tabs' });

const props = defineProps({
  active: {
    type: [String, Number],
    default: '',
  },
  data: {
    type: Array,
    default: () => [],
  },
});
const emit = defineEmits(['update:active', 'change', 'scroll-to']);
const tabsContainer = ref(null);
const targetScrollLeft = ref(0)
const tabElements = ref(new Map());
// 存储tab元素的引用
const setTabRef = (el, index) => {
  if (el) {
    tabElements.value.set(index, el);
  }
};

const handleTabClick = async (index) => {
  if (index === props.active) {
    emit('scroll-to')
    return
  }
  emit('update:active', index)
  emit('change', props.data[index]?.date || null)
  // 等待DOM更新
  await nextTick();

  const clickedTab = index === null ? tabsContainer.value.querySelector('.unmarked') : tabElements.value.get(index);
  if (!clickedTab || !tabsContainer.value) return;
  smoothScrollToTab(clickedTab);
};

const smoothScrollToTab = (tabElement) => {
  const container = tabsContainer.value;
  if (!container || !tabElement) return;

  const containerRect = container.getBoundingClientRect();
  const tabRect = tabElement.getBoundingClientRect();

  const containerCenter = containerRect.width / 2;
  const tabCenter = tabRect.left - containerRect.left + tabRect.width / 2;

  targetScrollLeft.value = container.scrollLeft + (tabCenter - containerCenter);

  container.scrollTo({
    left: Math.max(0, targetScrollLeft.value),
    behavior: 'smooth',
  });
};

onActivated(() => {
  tabsContainer.value.scrollTo({ left: Math.max(0, targetScrollLeft.value) })
})
</script>
